import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";
import history from "../../../router/browserrouter";
import { store } from "../../store";
export default function* watcherAddInventorySaga() {
  yield takeEvery("ADD_INVENTORY", workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: "DISPLAY_LOADER" });
    let payload = {};
    var url = "add-inventory";
    yield request("post", action.payload, url).then((response) => {
      payload = response;
    });
    toast.success(payload);
    var formatUrl =
      "api/Admin/get-user-location-dropdown?userId=" +
      store.getState().persistReducer.userId;
    yield request("get", action.payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "LOCATIONS_LIST_DROPDOWN", payload: payload });

    formatUrl =
      "api/Admin/get-product-dropdown?id=" +
      store.getState().persistReducer.companyId;
    yield request("get", payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "PRODUCT_DROPDOWN_LIST", payload: payload });
    formatUrl = "get-inventory/";
    yield request("get", payload, formatUrl).then((response) => {
      payload = response;
    });
    yield put({ type: "INVENTORIES_LIST", payload: payload });

    // Dashboard call to update the state of the dashboard details
    yield request("get", action.payload, "/get-inventory-dashboard").then(
      (response) => {
        payload = response;
      }
    );
    var inventoryValue = payload.inventoryValue;
    yield put({ type: "SET_INVENTORYVALUE", payload: inventoryValue });
    localStorage.setItem("inventoryValue", inventoryValue);

    //
    yield request("get", action.payload, "/get-inventory-dashboard").then(
      (response) => {
        payload = response;
      }
    );
    var retailValue = payload.retailValue;
    yield put({ type: "SET_RETAILVALUE", payload: retailValue });
    localStorage.setItem("retailValue", retailValue);
    //

    yield request("get", action.payload, "/get-inventory-dashboard").then(
      (response) => {
        payload = response;
      }
    );
    var potentialProfit = payload.potentialProfit;
    yield put({ type: "SET_POTENTIALPROFIT", payload: potentialProfit });
    localStorage.setItem("potentialProfit", potentialProfit);

    //
    yield request("get", action.payload, "/get-inventory-dashboard").then(
      (response) => {
        payload = response;
      }
    );
    var grossMargin = payload.grossMargin;
    yield put({ type: "SET_GROSSMARGIN", payload: grossMargin });

    // End Dashboard call

    yield put({ type: "DISPLAY_LOADER" });
  } catch (e) {
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    console.log("add-product-saga", e);
    yield put({ type: "DISPLAY_LOADER" });
    console.log("add-product-saga", e.response);
    console.log(e.response);
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
  }
}
